import { parse } from 'cookie';

export const RefreshTokenCookie = {
  name: '__ha_rt',
  parse: (cookie: string) => parse(cookie)[RefreshTokenCookie.name],
};

export const AccessTokenCookie = {
  name: '__ha_at',
  parse: (cookie: string) => parse(cookie)[AccessTokenCookie.name],
};

export const CodeVerifierCookie = {
  name: '__ha_cv',
  parse: (cookie: string) => parse(cookie)[CodeVerifierCookie.name],
};

export const StateCookie = {
  name: '__ha_s',
  parse: (cookie: string) => parse(cookie)[StateCookie.name],
};

export const AccessTokenExpiresInCookie = {
  name: '__ha_at_exp',
  parse: (cookie: string) => parse(cookie)[AccessTokenExpiresInCookie.name],
};

export const AccessTokenExpiresAtCookie = {
  name: '__ha_at_exp_at',
  parse: (cookie: string) => parse(cookie)[AccessTokenExpiresAtCookie.name],
};

export const IdTokenCookie = {
  name: '__ha_it',
  parse: (cookie: string) => parse(cookie)[IdTokenCookie.name],
};
